import React from "react";
import { PageTitle } from "./PageTitle";
import { Layout, Spin } from "antd";
import { Error403 } from "../ErrorPages/Error403";
import "../Style/Page.css";
import { AuthContext } from "../Auth/Auth";
const { Content } = Layout;

interface Props {
  isPageLoading?: boolean;
  title?: string;
  noCheckAuthority?: boolean;
  children: React.ReactNode;
}

export default class Page extends React.Component<Props> {
  static contextType = AuthContext;

  state = {
    isPageLoading: false,
  };

  constructor(props: Props) {
    super(props);
    if (props.isPageLoading) {
      this.state.isPageLoading = props.isPageLoading!;
    }
  }

  componentDidMount() {
    if (sessionStorage.getItem("auth")) {
      this.context.refreshToken(sessionStorage.getItem("auth"));
    }
  }

  render() {
    let authorityOk = false;
    const href = window.location.href + "/";
    if (this.props.noCheckAuthority) {
      authorityOk = true;
    } else {
      if (this.context.user.userAuthoritys != null) {
        this.context.user.userAuthoritys.every((element: any) => {
          if (
            element.appURL != null &&
            element.appURL.length > 0 &&
            href.indexOf(element.appURL + "/") !== -1
          ) {
            authorityOk = true;
            return false;
          } else {
            return true;
          }
        });
      }
      if (!authorityOk) {
        if (href.indexOf("/ScoringResultView/") !== -1) {
          if (this.context.user.browsePastFlag === "1") {
            authorityOk = true;
          }
        } else if (href.indexOf("/ScoringUpdate/") !== -1) {
          if (this.context.user.superUpdateFlag === "1") {
            authorityOk = true;
          }
        } else if (href.indexOf("/ScoringConfirm/") !== -1) {
          if (this.context.user.superUpdateFlag === "1") {
            authorityOk = true;
          }
        }
      }
    }
    if (!authorityOk) {
      return (
        <Content>
          <Error403 />
        </Content>
      );
    } else {
      return (
        <Content>
          <Spin spinning={this.state.isPageLoading}>
            {this.props.title && <PageTitle>{this.props.title}</PageTitle>}
            {this.props.children}
          </Spin>
        </Content>
      );
    }
  }
}
